import { Box, Button, Container, Typography } from "@material-ui/core"
import {
  getPaymentGetBit,
  getPaymentPaymentMethods,
  postPaymentPaymentDoneBit,
} from "api"
import { useIsDesktop } from "common/MediaQueries"
import BackButton from "components/BackButton/BackButton"
import GenericButton from "components/GenericButton/GenericButton"
import {
  bitPay,
  loadBitCom,
  savePaymentDataToLocalStorage,
} from "components/PurchasePage/Preview/Payment/bitHelpers"
import { usePaymentContext } from "components/PurchasePage/Preview/Payment/PaymentContext"
import { usePurchaseContext } from "components/PurchasePage/PurchaseContext"
import { useQuickPurchaseContext } from "components/QuickPurchasePage/QuickPurchaseContext"
import LoaderPopup from "components/Reusable/LoaderPopup"
import { useRouter } from "next/router"
import { useEffect, useMemo, useState } from "react"
import {
  isAndroid,
  isChrome,
  isEdge,
  isFirefox,
  isIOS,
  isOpera,
  isSafari,
} from "react-device-detect"
import styled from "styled-components"
import { PaymentSteps } from "~/pages/payment"

const StyledWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 76px 16px 40px 16px;
  gap: 32px;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 108px 60px 60px 60px;
    gap: 48px;
  }
`

const StyledSummaryContainer = styled.div`
  border-radius: 16px;
  border: 1px solid var(--Light-Grey, #f7f7f7);
  max-width: 1056px;
  min-height: 200px;
`

const StyledHeader = styled.div`
  position: relative;
  padding: 0 16px;
  border-radius: 16px;
  min-height: 106px;

  ${(p) => p.theme.breakpoints.up("md")} {
    background-image: url(/yellow-header.svg);
    background-size: "1056px 106px;";
    background-repeat: no-repeat;
    padding: 0 60px;
  }
`

const StyledImg = styled.img`
  position: absolute;
  left: 0;
  z-index: -5;
  border-radius: 16px;
`

const StyledHeaderText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 13px;

  ${(p) => p.theme.breakpoints.up("md")} {
  }
`

const StyledPersonDetailsContainer = styled.div`
  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
  }
`

const defaultText = `
  color: var(--Black, var(--Primary-Black, #000));
  text-align: right;
  font-family: Speedee, NarkisBlock;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
  padding: 0;
`

const StyledHeaderTitle = styled.h2`
  ${defaultText}
  font-size: 26px;
  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 32px;
  }
`

const StyledHeaderInfo = styled.div``

const StyledTopLine = styled.p`
  ${defaultText}
  font-size: 20px;

  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 26px;
  }
`

const StyledAmount = styled.span`
  ${defaultText}
  font-size: 24px;

  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 26px;
  }
`

const StyledCurrency = styled.span`
  ${defaultText}
  font-size: 20px;
  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 20px;
  }
`

const StyledBottomLine = styled.p`
  ${defaultText}
  font-size: 14px;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 20px;
  }
`

const StyledPersonDetails = styled.div`
  padding: 16px;
  border-bottom: 1px solid var(--Light-Grey, #f7f7f7);

  ${(p) => p.theme.breakpoints.up("md")} {
    border-bottom: none;
    padding: 0 60px 16px 80px;
    margin-top: 35px;

    &:first-child {
      border-left: 2px solid var(--Light-Grey, #f7f7f7);
    }
  }
`

const StyledPersonTitle = styled.p`
  ${defaultText}
  font-size: 20px;

  font-weight: bold;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;

    margin-bottom: 16px;
  }
`

const StyledDetails = styled.p`
  ${defaultText}
  font-size: 18px;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 20px;
  }
`

const StyledEmail = styled.p`
  ${defaultText}
  font-size: 14px;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 18px;
  }
`

const StyledPaymentButtons = styled.div`
  padding: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin: 60px 60px 0 60px;
    padding: 0 0 60px 0;
  }
`

const StyledPaymentTitle = styled.p`
  ${defaultText}
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
  }
`

const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${(p) => p.theme.breakpoints.up("md")} {
    gap: 24px;
    flex-direction: row;
  }
`

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 48px;

  border-radius: 8px;
  border: 2px solid var(--Yellow, #ffbc0d);
  background: var(--White, #fff);

  &:hover {
    box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);
    background: #fff;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 296px;
    padding: 10px 10px 10px 20px;
  }
`

const StyledButtonHeText = styled.p`
  ${defaultText}
  font-size: 24px;
  font-weight: bold;
`

const StyledBitButton = styled(Button)`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: linear-gradient(180deg, #2b5586 0%, #3b96b1 100%);

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 296px;
  }
`

const StyledBitText = styled.p`
  ${defaultText}
  color: var(--White, #FFF);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
`

const StyledButtonIcon = styled.img``

const StyledButtonInner = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`

const NoPaymentWrapper = styled.div`
  text-align: right;
`

const NoPaymentSubtitle = styled(Typography).attrs({ variant: "body1" })`
  font-size: 24px;
  line-height: 30px;
  font-weight: 400;
  text-align: right;
`

type PaymentType = "apple/google" | "creditCard"

const PurchaseSummaryPage = () => {
  const isDesktop = useIsDesktop()

  const {
    setShowExitModal,
    discount,
    quickPurchaseInputValues,
    setshowStickyBottom,
    priceAfterDiscount,
  } = useQuickPurchaseContext()

  const {
    amount,
    RecipientName,
    RecipientMobilePhone,
    RecipientEmail,
    SenderName,
    SenderMobilePhone,
    SenderEmail,
  } = quickPurchaseInputValues

  const {
    purchaseData,
    blessingMode,
    selectedGiftCard,
    giftCardLoadAmount,
    giftCardPrice,
    addPercentage,
    orderId,
    orderRecipientGuid,
    setPaymentInitiationId,
    setTransactionSerialId,
  } = usePurchaseContext()

  const [loading, setLoading] = useState(false)
  const [availablePayment, setAvailablePayment] = useState(null)

  const { setPaymentSteps } = usePaymentContext()

  const router = useRouter()

  useEffect(() => {
    setshowStickyBottom(false)

    if (!purchaseData || !amount || !orderId) {
      router.push("/")
    }
  }, [])

  useEffect(() => {
    const getPaymentTypes = async () => {
      const { data } = await getPaymentPaymentMethods(
        orderId,
        isChrome
          ? "chrome"
          : isSafari
          ? "safari"
          : isFirefox
          ? "firefox"
          : isOpera
          ? "opera"
          : isEdge
          ? "edge"
          : "other browser",
        null
      )
      setAvailablePayment(data.body)
    }
    getPaymentTypes()
  }, [])

  const allValuesFalse = useMemo(
    () =>
      availablePayment &&
      Object.values(availablePayment).every((value) => value === false),
    [availablePayment]
  )

  /**
   * This function will be called when a user selects a payment option
   */
  useEffect(() => {
    const storedData = localStorage.getItem(orderRecipientGuid)
    if (storedData) {
      const { expirationTime } = JSON.parse(storedData)
      const currentTime = new Date().getTime()

      if (currentTime > expirationTime) {
        localStorage.removeItem(orderRecipientGuid)
      }
    }
  }, [])

  const handlePaymentSelection = (paymentOption: PaymentType) => {
    if (!paymentOption || !orderId) return
    if (paymentOption === "creditCard") router.push("payment/creditCard")
    if (paymentOption === "apple/google") router.push("payment/wallet")
  }

  /**
   * Handling bit payment
   *
   *
   */

  const payBit = (transactionSerialId: string, paymentInitiationId: string) => {
    bitPay({
      transactionSerialId,
      paymentInitiationId,
      onApproval: async () => {
        try {
          setLoading(true)
          await postPaymentPaymentDoneBit({
            paymentInitiationId: paymentInitiationId,
          })
          setLoading(false)
          setPaymentSteps(PaymentSteps.SUCCESS)
        } catch (error) {
          setLoading(false)
          setPaymentSteps(PaymentSteps.FAILURE)
          console.log(error)
        }
      },
      onCancel: async () => {
        try {
          setLoading(true)

          await postPaymentPaymentDoneBit({
            paymentInitiationId: paymentInitiationId,
          })

          setLoading(false)
        } catch (error) {
          setLoading(false)
          console.log(error)
        }
      },
    })
  }

  const getBitPayment = async () => {
    try {
      setLoading(true)
      const { data } = await getPaymentGetBit(
        orderId,
        isChrome
          ? "chrome"
          : isSafari
          ? "safari"
          : isFirefox
          ? "firefox"
          : isOpera
          ? "opera"
          : isEdge
          ? "edge"
          : "other browser"
      )
      setLoading(false)

      if (!isDesktop) {
        savePaymentDataToLocalStorage(orderRecipientGuid, {
          paymentData: data.body,
          purchaseData: purchaseData,
          selectedGiftCard: selectedGiftCard,
          blessingMode: blessingMode,
          giftCardLoadAmount: giftCardLoadAmount,
          giftCardPrice: giftCardPrice,
          addPercentage: addPercentage,
          orderId: orderId,
          orderRecipientGuid: orderRecipientGuid,
        })
      }
      setTransactionSerialId(data.body.transactionSerialId)
      setPaymentInitiationId(data.body.paymentInitiationId)

      loadBitCom({
        isDesktop,
        orderRecipientGuid,
        paymentInitiationId: data.body.paymentInitiationId,
        transactionSerialId: data.body.transactionSerialId,
        isAndroid,
        isIOS,
        pay: payBit,
      })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  if (!amount) return <></>
  return (
    <>
      <StyledWrapper>
        <Box>
          <BackButton
            linkText="חזרה"
            padding="7px 0 0 0"
            mobilePadding="18px 0 0 0"
            preventNavigation={true}
            beforeNavigation={() => setShowExitModal(true)}
          />
        </Box>
        <StyledSummaryContainer>
          <StyledHeader>
            {!isDesktop && (
              <StyledImg src="/yellow-header-small.svg" width="100%" />
            )}
            <StyledHeaderText>
              <StyledHeaderTitle>סיכום פרטים</StyledHeaderTitle>
              <StyledHeaderInfo>
                <StyledTopLine>
                  סה״כ לתשלום: <StyledCurrency>₪</StyledCurrency>
                  <StyledAmount>{priceAfterDiscount || "0"}</StyledAmount>
                </StyledTopLine>
                {discount > 0 && (
                  <StyledBottomLine>
                    לאחר שווי הנחה של {discount || 0}%
                  </StyledBottomLine>
                )}
              </StyledHeaderInfo>
            </StyledHeaderText>
          </StyledHeader>
          <StyledPersonDetailsContainer>
            <StyledPersonDetails>
              <StyledPersonTitle>למי המתנה</StyledPersonTitle>
              <StyledDetails>{RecipientName || ""}</StyledDetails>
              <StyledDetails>{RecipientMobilePhone || ""}</StyledDetails>
              <StyledEmail>{RecipientEmail || ""}</StyledEmail>
            </StyledPersonDetails>
            <StyledPersonDetails>
              <StyledPersonTitle>הפרטים שלי</StyledPersonTitle>
              <StyledDetails>{SenderName || ""}</StyledDetails>
              <StyledDetails>{SenderMobilePhone || ""}</StyledDetails>
              <StyledEmail>{SenderEmail || ""}</StyledEmail>
            </StyledPersonDetails>
          </StyledPersonDetailsContainer>
          {!allValuesFalse ? (
            <StyledPaymentButtons>
              <StyledPaymentTitle>בחירת אפשרויות לתשלום</StyledPaymentTitle>
              <StyledButtonsContainer>
                {availablePayment?.creditCard && (
                  <StyledButton
                    onClick={() => handlePaymentSelection("creditCard")}
                    aria-label="תשלום באמצעות כרטיס אשראי"
                  >
                    <StyledButtonInner>
                      <StyledButtonIcon src="/credit-card-icon.svg" />
                      <StyledButtonHeText>כרטיס אשראי</StyledButtonHeText>
                    </StyledButtonInner>
                  </StyledButton>
                )}
                {availablePayment?.wallet && (
                  <StyledButton
                    onClick={() => handlePaymentSelection("apple/google")}
                    aria-label="תשלום באמצעות ארנק דיגיטלי גוגל פיי או אפל פיי"
                  >
                    <StyledButtonInner>
                      <StyledButtonIcon src="/pay-icon.svg" />
                      <StyledButtonIcon src="/google-pay-icon.svg" />
                      <StyledButtonIcon src="/icon-divider.svg" />
                      <StyledButtonIcon src="/pay-icon.svg" />
                      <StyledButtonIcon src="/apple-pay-icon.svg" />
                    </StyledButtonInner>
                  </StyledButton>
                )}

                {availablePayment?.bit && (
                  <StyledBitButton
                    onClick={() => getBitPayment()}
                    aria-label="תשלום באמצעות ביט"
                  >
                    <StyledButtonInner>
                      <StyledBitText>תשלום באמצעות</StyledBitText>
                      <StyledButtonIcon src="/bit-logo-icon.svg" />
                    </StyledButtonInner>
                  </StyledBitButton>
                )}
              </StyledButtonsContainer>
            </StyledPaymentButtons>
          ) : (
            <NoPaymentWrapper>
              <StyledPaymentTitle>
                אופסי, אי אפשר לבצע רכישה כרגע באתר
              </StyledPaymentTitle>
              <NoPaymentSubtitle>
                אנחנו על זה! בבקשה לנסות שוב בקרוב
              </NoPaymentSubtitle>
              <GenericButton
                btnType="filled"
                onClick={() => router.push("/quick-purchase")}
              >
                בואו ננסה שוב
              </GenericButton>
            </NoPaymentWrapper>
          )}
        </StyledSummaryContainer>
        <LoaderPopup isOpen={loading} />
      </StyledWrapper>
    </>
  )
}

export default PurchaseSummaryPage
